import React, {Component} from 'react';
import {gpn} from "../GPN"
import config from "../config";
import Header from "../sections/Header";
import {Route, Routes} from "react-router-dom";
import Login from "./Login";
import Home from "./Home";
import req from "../req";
import {toast} from "react-toastify";
import ModalLoading from "../sections/ModalLoading";
import Profile from "./Profile";
import Facilities from "./Facilities";
import Help from "./Help";
import About from "./About";
import Contact from "./Contact";
import SuccessPayment from "./SuccessPayment";
import ErrorPayment from "./ErrorPayment";
import Orders from "./Orders";
import Payments from "./Payments";
import Services from "./Services";
import BottomNav from "./BottomNav";

class App extends Component {

    state = {
        title: "قسطی تک",
        info: null
    };

    componentDidMount() {
        let token = config.token;
        if (token === "" && document.location.pathname !== "/login") {
            document.location.href = "/login";
        } else {
            if (token !== "") {
                this.getInfo(false);
            }
        }
    }




    getInfo(anotherComponent = false) {
        req.getRequest(`${config.api}/user/info`)
            .then(r => {
                if (!anotherComponent) {
                    try {
                        if (r) {
                            this.setState({info: r});
                        } else {
                            try {
                                toast.error("لطفاً وارد شوید!");
                                localStorage.removeItem("token");
                                document.location.href = "/login";
                            } catch (err) {
                            }
                        }
                    } catch (err) {
                    }
                }
            })
            .catch(err => {
                if (!anotherComponent) {
                    try {
                        let error = config.handleError(err);
                        if (error.includes("دسترسی رد شد")) {
                            toast.error("لطفاً وارد شوید!");
                            try {
                                localStorage.removeItem("token");
                                if (document.location.pathname !== "/login") {
                                    document.location.href = "/login";
                                }
                            } catch (err) {
                            }
                        }
                    } catch (err) {
                    }
                }
            });
    }

    setTitle = (t = "") => {
        config.setTitle(t)
        this.setState({
            title: t
        });
        config.scrollTop();
    }

    render() {
        const {title, info} = this.state;

        let path = "/";
        try {
            if (typeof document !== "undefined") {
                if (document) {
                    path = document.location.pathname;
                }
            }
        } catch (err) {

        }
        let ro = {
            setTitle: this.setTitle.bind(this),
            info,
            getInfo: this.getInfo,
            path
        }

        return (
            <main className="parent" id="parent">
                <ModalLoading loading={info === null && document.location.pathname !== "/login"}/>
                <Header title={title} {...ro}/>

                <div className="main">
                    <Routes>
                        {
                            config.token !== "" ?
                                <>
                                    <Route path="/services" element={<Services {...ro} />}/>
                                    <Route path="/payments" element={<Payments {...ro} />}/>
                                    <Route path="/orders" element={<Orders {...ro} />}/>
                                    <Route path="/payment/success/:ref/" element={<SuccessPayment {...ro} />}/>
                                    <Route path="/payment/error" element={<ErrorPayment {...ro} />}/>
                                    <Route path="/contact" element={<Contact {...ro} />}/>
                                    <Route path="/about" element={<About {...ro} />}/>
                                    <Route path="/help" element={<Help {...ro} />}/>
                                    <Route path="/facilities" element={<Facilities {...ro} />}/>
                                    <Route path="/profile" element={<Profile {...ro} />}/>
                                    <Route path="/login" element={<Login {...ro} />}/>
                                    <Route path="/" element={<Home {...ro} />}/>
                                </>
                                :
                                <>
                                    <Route path="/login" element={<Login {...ro} />}/>
                                </>
                        }
                    </Routes>
                </div>

                <BottomNav {...ro}/>
            </main>
        );
    }
}

export default gpn(App);